import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { ToastContainer } from 'react-toastify';

import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Home from './components/pages/Home';
import DashboardLayout from './components/panel/DashboardLayout';
import NotFound from './components/pages/Notfound';
import Loginhistory from './components/pages/Loginhistory';
import Usermgmt from './components/pages/Usermgmt';
import Allincomereport from './components/pages/Allincomereport';
import Allexpensereport from './components/pages/Allexpensereport';

import Shop from './components/Shop/Shop';
import Wholesalehome from './components/Wholesale/Wholesalehome';
import Fianancehome from './components/Fianance/Fianancehome';
import Takkevarihome from './components/Takkevari/Takkevarihome';
import Payrolehome from './components/Payrole/Payrolehome';
import Mashalhome from './components/Mashal/Mashalhome';
import Udharihome from './components/Udhari/Udharihome';

import Products from './components/Inventory/Products';
import Customer from './components/Inventory/Customer';
import Sale from './components/Inventory/Sale';
import Productsize from './components/Inventory/Productsize';
import Vendors from './components/Inventory/Vendors';
import Purchase from './components/Inventory/Purchase';
import ViewPurchase from './components/Inventory/ViewPurchase';
import Vendoraccount from './components/Inventory/Vendoraccount';
import Editpurchase from './components/Inventory/Editpurchase';
import Viewsale from './components/Inventory/Viewsale';
import CustomerAccountsSummary from './components/Inventory/Customeraccount';
import EditSale from './components/Inventory/EditSale';
import Salereport from './components/Inventory/Salereport';
import Purchasereport from './components/Inventory/Purchasereport';
import Customerreport from './components/Inventory/Customerreport';
import Vendorreport from './components/Inventory/Vendorreport';
import Incomereport from './components/Inventory/Incomereport';
import Expensereport from './components/Inventory/Expensereport';
import Customeroustanding from './components/Inventory/Customeroustanding';
import Vendoroutstanding from './components/Inventory/Vendoroutstanding';
import PrintInvoice from './components/Inventory/Printinvoice';

import Staffcategory from './components/Payrole/Staffcategory';
import Staffdetails from './components/Payrole/Staffdetails';
import Staffadvance from './components/Payrole/Staffadvance';
import Staffmonthlypayment from './components/Payrole/Staffmonthlypayment';
import Staffpayreport from './components/Payrole/Staffpayreport';
import Staffattendece from './components/Payrole/Staffattendece';

import FiananceCust from './components/Fianance/FiananceCust';
import Loangiven from './components/Fianance/Loangiven';
import Emitaken from './components/Fianance/Emitaken';
import Emidetails from './components/Fianance/Emidetails';
import Loanreport from './components/Fianance/Loanreport';
import Loancustreport from './components/Fianance/Loancustreport';
import Emireport from './components/Fianance/Emireport';

import Takkevaricust from './components/Takkevari/Takkevaricust';
import Amountgiven from './components/Takkevari/Amountgiven';
import Intresttaken from './components/Takkevari/Intresttaken';
import Intresthistory from './components/Takkevari/Intresthistory';
import Takkevarucsutreport from './components/Takkevari/Takkevarucsutreport';
import Amountgivenreport from './components/Takkevari/Amountgivenreport';
import Intrestreport from './components/Takkevari/Intrestreport';

import Udharidene from './components/Udhari/Udharidene';
import Usaneghene from './components/Udhari/Usaneghene';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return null;

  return (
    <BrowserRouter>
      <Routes>
        {user ? (
          <>
            <Route path="/home" element={
              <DashboardLayout>
                <Home />
              </DashboardLayout>
            } />

            <Route path="/customers-mgmt/:category" element={<DashboardLayout><Customer /></DashboardLayout>} />
            <Route path="/sales/:category" element={<DashboardLayout><Sale /></DashboardLayout>} />
            <Route path="/products/:category" element={<DashboardLayout><Products /></DashboardLayout>} />
            <Route path="/product-sizes/:category" element={<DashboardLayout><Productsize /></DashboardLayout>} />
            <Route path="/vendors-mgmt/:category" element={<DashboardLayout><Vendors /></DashboardLayout>} />
            <Route path="/purchase/:category" element={<DashboardLayout><Purchase /></DashboardLayout>} />
            <Route path="/vendors-account/:category" element={<DashboardLayout><Vendoraccount /></DashboardLayout>} />
            <Route path="/view-purchase/:category" element={<ViewPurchase />} />
            <Route path="/edit-purchase/:category/:purchaseId" element={<Editpurchase />} />
            <Route path="/view-sale/:category" element={<Viewsale />} />
            <Route path="/customers-account/:category" element={<DashboardLayout><CustomerAccountsSummary /></DashboardLayout>} />
            <Route path="/edit-sale/:category/:saleId" element={<EditSale />} />
            <Route path="/reports-sales/:category" element={<Salereport />} />
            <Route path="/reports-purchase/:category" element={<Purchasereport />} />
            <Route path="/reports-customers/:category" element={<Customerreport />} />
            <Route path="/reports-vendors/:category" element={<Vendorreport />} />
            <Route path="/reports-income/:category" element={<Incomereport />} />
            <Route path="/reports-expense/:category" element={<Expensereport />} />
            <Route path="/reports-customer-outstanding/:category" element={<Customeroustanding />} />
            <Route path="/reports-vendor-outstanding/:category" element={<Vendoroutstanding />} />
            <Route path="/print-invoice/:saleId" element={<PrintInvoice />} />

            <Route path="/category/shop" element={<DashboardLayout><Shop /></DashboardLayout>} />
            <Route path="/category/wholesaler" element={<DashboardLayout><Wholesalehome /></DashboardLayout>} />
            <Route path="/category/mashal" element={<DashboardLayout><Mashalhome /></DashboardLayout>} />
            <Route path="/category/finance" element={<DashboardLayout><Fianancehome /></DashboardLayout>} />
            <Route path="/category/takkevari" element={<DashboardLayout><Takkevarihome /></DashboardLayout>} />
            <Route path="/category/payroll" element={<DashboardLayout><Payrolehome /></DashboardLayout>} />
            <Route path="/category/udhari" element={<DashboardLayout><Udharihome /></DashboardLayout>} />

            <Route path="/staff/category" element={<DashboardLayout><Staffcategory /></DashboardLayout>} />
            <Route path="/staff/details" element={<DashboardLayout><Staffdetails /></DashboardLayout>} />
            <Route path="/staff/advance-payment" element={<DashboardLayout><Staffadvance /></DashboardLayout>} />
            <Route path="/staff/monthly-payment" element={<DashboardLayout><Staffmonthlypayment /></DashboardLayout>} />
            <Route path="/reports-staff-payments" element={<DashboardLayout><Staffpayreport /></DashboardLayout>} />
            <Route path="/staff-attendance/:staffid" element={<Staffattendece />} />

            <Route path="/finance/customer-account" element={<DashboardLayout><FiananceCust /></DashboardLayout>} />
            <Route path="/finance/loans/given" element={<DashboardLayout><Loangiven /></DashboardLayout>} />
            <Route path="/finance/loans/emi-taken" element={<DashboardLayout><Emitaken /></DashboardLayout>} />
            <Route path="/emidetails/:loanid" element={<DashboardLayout><Emidetails /></DashboardLayout>} />
            <Route path="/finance/reports/loan-report" element={<DashboardLayout><Loanreport /></DashboardLayout>} />
            <Route path="/finance/reports/customer-report" element={<DashboardLayout><Loancustreport /></DashboardLayout>} />
            <Route path="/finance/reports/emi-report" element={<DashboardLayout><Emireport /></DashboardLayout>} />

            <Route path="/takkevari/customers" element={<DashboardLayout><Takkevaricust /></DashboardLayout>} />
            <Route path="/takkevari/amount-taken" element={<DashboardLayout><Amountgiven /></DashboardLayout>} />
            <Route path="/takkevari/interest-taken" element={<DashboardLayout><Intresttaken /></DashboardLayout>} />
            <Route path="/viewintresthistory/:loanid" element={<DashboardLayout><Intresthistory /></DashboardLayout>} />
            <Route path="/takkevari/reports/customers" element={<DashboardLayout><Takkevarucsutreport /></DashboardLayout>} />
            <Route path="/takkevari/reports/amounts" element={<DashboardLayout><Amountgivenreport /></DashboardLayout>} />
            <Route path="/takkevari/reports/interests" element={<DashboardLayout><Intrestreport /></DashboardLayout>} />

            <Route path="/expense-report" element={<DashboardLayout><Allexpensereport /></DashboardLayout>} />
            <Route path="/income-report" element={<DashboardLayout><Allincomereport /></DashboardLayout>} />
            <Route path="/users-mgmt" element={<DashboardLayout><Usermgmt /></DashboardLayout>} />
            <Route path="/login-history" element={<DashboardLayout><Loginhistory /></DashboardLayout>} />
            <Route path="*" element={<NotFound />} />

            <Route path="/udhari/udhari-dene" element={<DashboardLayout><Udharidene /></DashboardLayout>} />
            <Route path="/udhari/udhari-ghene" element={<DashboardLayout><Usaneghene /></DashboardLayout>} />


          </>
        ) : (
          <>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register12345" element={<Register />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>

      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
